// This file was automatically generated by graphql-code-generator
// Changes to this file will be lost


import * as Types from '../../../engine/apis/magento2/types.generated.d';

import { gql } from '@apollo/client';
export type CartCheckoutDetailsFieldsFragment = { __typename?: 'Cart', id: string, email?: string | null, prices?: { __typename?: 'CartPrices', subtotal_excluding_tax?: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } | null, discounts?: Array<{ __typename?: 'Discount', amount: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null, applied_taxes?: Array<{ __typename?: 'CartTaxItem', label: string, amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null> | null, grand_total?: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } | null } | null, applied_coupons?: Array<{ __typename?: 'AppliedCoupon', code: string } | null> | null, shipping_addresses: Array<{ __typename?: 'ShippingCartAddress', firstname: string, lastname: string, company?: string | null, street: Array<string | null>, city: string, postcode?: string | null, telephone?: string | null, region?: { __typename?: 'CartAddressRegion', code?: string | null, label?: string | null, region_id?: number | null } | null, country: { __typename?: 'CartAddressCountry', code: string, label: string }, available_shipping_methods?: Array<{ __typename?: 'AvailableShippingMethod', available: boolean, carrier_code: string, carrier_title: string, error_message?: string | null, method_code?: string | null, method_title?: string | null, amount: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, price_excl_tax: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null }, price_incl_tax: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null, selected_shipping_method?: { __typename?: 'SelectedShippingMethod', method_code: string, carrier_code: string, method_title: string, amount: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null } | null>, billing_address?: { __typename?: 'BillingCartAddress', firstname: string, lastname: string, company?: string | null, street: Array<string | null>, city: string, postcode?: string | null, telephone?: string | null, region?: { __typename?: 'CartAddressRegion', code?: string | null, label?: string | null, region_id?: number | null } | null, country: { __typename?: 'CartAddressCountry', code: string, label: string } } | null, available_payment_methods?: Array<{ __typename?: 'AvailablePaymentMethod', code: string, title: string } | null> | null, selected_payment_method?: { __typename?: 'SelectedPaymentMethod', code: string } | null };

export const CartCheckoutDetailsFieldsFragmentDoc = gql`
    fragment CartCheckoutDetailsFields on Cart {
  id
  email
  prices {
    subtotal_excluding_tax {
      value
      currency
    }
    discounts {
      amount {
        value
        currency
      }
    }
    applied_taxes {
      amount {
        currency
        value
      }
      label
    }
    grand_total {
      value
      currency
    }
  }
  applied_coupons {
    code
  }
  shipping_addresses {
    firstname
    lastname
    company
    street
    city
    region {
      code
      label
      region_id
    }
    postcode
    telephone
    country {
      code
      label
    }
    available_shipping_methods {
      amount {
        currency
        value
      }
      available
      carrier_code
      carrier_title
      error_message
      method_code
      method_title
      price_excl_tax {
        value
        currency
      }
      price_incl_tax {
        value
        currency
      }
      carrier_code
      carrier_title
      method_code
      method_title
    }
    selected_shipping_method {
      method_code
      carrier_code
      method_title
      amount {
        value
        currency
      }
    }
  }
  billing_address {
    firstname
    lastname
    company
    street
    city
    region {
      code
      label
      region_id
    }
    postcode
    telephone
    country {
      code
      label
    }
  }
  available_payment_methods {
    code
    title
  }
  selected_payment_method {
    code
  }
}
    `;